import { render, staticRenderFns } from "./friend-fans.vue?vue&type=template&id=3d2eeaf0&scoped=true"
import script from "./friend-fans.vue?vue&type=script&lang=js"
export * from "./friend-fans.vue?vue&type=script&lang=js"
import style0 from "./friend-fans.vue?vue&type=style&index=0&id=3d2eeaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2eeaf0",
  null
  
)

export default component.exports